// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-routine-bottom-sheet-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.create-routine-bottom-sheet-content .routine-types-grid {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
}

.bottom-sheet-actions {
  display: flex;
  gap: 12px;
  padding: 16px 0;
  border-top: 1px solid var(--color-light-gray);
  margin-top: auto;
  flex-shrink: 0;
}

.cancel-button,
.create-button {
  flex: 1;
  height: 48px;
}

/* Banner section styling to match search section */
.create-routine-bottom-sheet-content .banner {
  margin-bottom: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--color-light-gray);
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/CreateRoutineBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,eAAe;EACf,gDAAgD;AAClD","sourcesContent":[".create-routine-bottom-sheet-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.create-routine-bottom-sheet-content .routine-types-grid {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 0;\n}\n\n.bottom-sheet-actions {\n  display: flex;\n  gap: 12px;\n  padding: 16px 0;\n  border-top: 1px solid var(--color-light-gray);\n  margin-top: auto;\n  flex-shrink: 0;\n}\n\n.cancel-button,\n.create-button {\n  flex: 1;\n  height: 48px;\n}\n\n/* Banner section styling to match search section */\n.create-routine-bottom-sheet-content .banner {\n  margin-bottom: 16px;\n  padding: 16px 0;\n  border-bottom: 1px solid var(--color-light-gray);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
